import { SearchHeader } from '@containers/Headers/SearchHeader'
import { ScreenContainer } from '@containers/ScreenContainer'
import { SearchProvider } from '@contexts/search'
import { useSiteFeatures } from '@hooks/siteFeatures'

import { SearchDownstreamTasks } from './Tasks/SearchDownstreamTasks'
import { SearchMidstreamTasks } from './Tasks/SearchMidstreamTasks'

export function SearchScreen() {
  const { isMidstreamProcess } = useSiteFeatures()

  return (
    <SearchProvider>
      <ScreenContainer header={<SearchHeader />}>
        {isMidstreamProcess ? (
          <SearchMidstreamTasks />
        ) : (
          <SearchDownstreamTasks />
        )}
      </ScreenContainer>
    </SearchProvider>
  )
}
